import { render, staticRenderFns } from "./daily-cargo-edit-flight-administration.vue?vue&type=template&id=72d90b21"
import script from "./daily-cargo-edit-flight-administration.vue?vue&type=script&lang=js"
export * from "./daily-cargo-edit-flight-administration.vue?vue&type=script&lang=js"
import style0 from "./daily-cargo-edit-flight-administration.vue?vue&type=style&index=0&id=72d90b21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports